import React, { useState, useEffect, useRef } from 'react';
import { coursesAPI, uploadsAPI } from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../styles/UploadLecture.css';
import { useNavigate } from 'react-router-dom';

const UploadLecture = () => {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [content, setContent] = useState('');
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const quillRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        navigate("/login");
        return;
      }
      try {
        const response = await coursesAPI.getAll();
        setCourses(response.data);
      } catch (error) {
        console.error("❌ Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, [navigate]);

  const handleUpload = async () => {
    if (!title || !selectedCourse || (!file && !content && !youtubeUrl)) {
      alert('❌ يرجى تعبئة الحقول المطلوبة.');
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('courseId', selectedCourse);
      formData.append('title', title);
      formData.append('description', description);
      formData.append('content', content);
      if (youtubeUrl) formData.append('youtubeUrl', youtubeUrl);
      if (file) formData.append('file', file);

      const response = await uploadsAPI.uploadLecture(formData);
      alert("✅ تم رفع المحاضرة بنجاح!");
      navigate(`/courses/${selectedCourse}`);
    } catch (error) {
      console.error("❌ فشل الرفع:", error);
      const serverError = error.response?.data?.error || error.response?.data?.message || "حدث خطأ غير متوقع";
      alert(`❌ فشل الرفع: ${serverError}`);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-page">
      <div className="upload-container">
        <div className="upload-header">
          <h2>📤 رفع محاضرة جديدة</h2>
          <p>أضف محتوى تعليمي جديد لطلابك</p>
        </div>

        <div className="form-section">
          <div className="form-group">
            <label>الدورة التدريبية</label>
            <select
              value={selectedCourse}
              onChange={(e) => setSelectedCourse(e.target.value)}
              className="form-control"
            >
              <option value="">-- اختر الدورة --</option>
              {courses.map(c => <option key={c.id} value={c.id}>{c.title}</option>)}
            </select>
          </div>

          <div className="form-group">
            <label>عنوان المحاضرة</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="مثال: مقدمة في الفيزياء النووية"
              className="form-control"
            />
          </div>

          <div className="form-group">
            <label>وصف مختصر</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="اكتب وصفاً قصيراً لمحتوى المحاضرة..."
              className="form-control"
              rows="3"
            />
          </div>

          <div className="form-group">
            <label>محتوى نصي (اختياري)</label>
            <div className="quill-wrapper">
              <ReactQuill
                ref={quillRef}
                value={content}
                onChange={setContent}
                theme="snow"
              />
            </div>
          </div>

          <div className="form-group">
            <label>رابط فيديو يوتيوب (اختياري)</label>
            <input
              type="text"
              value={youtubeUrl}
              onChange={(e) => setYoutubeUrl(e.target.value)}
              placeholder="https://www.youtube.com/watch?v=..."
              className="form-control"
              style={{ direction: 'ltr', textAlign: 'left' }}
            />
          </div>

          <div className="form-group file-upload-group">
            <label>ملف المحاضرة (PDF / فيديو)</label>
            <div className="file-drop-zone" onClick={() => document.getElementById('file-upload').click()}>
              <input
                type="file"
                id="file-upload"
                accept=".pdf,.mp4,.doc,.docx"
                onChange={(e) => setFile(e.target.files[0])}
                style={{ display: 'none' }}
              />
              <div className="drop-zone-content">
                <span className="upload-icon">📁</span>
                <p>{file ? file.name : "اضغط هنا لاختيار ملف أو اسحبه هنا"}</p>
              </div>
            </div>
          </div>

          <button
            onClick={handleUpload}
            disabled={uploading}
            className="btn-primary full-width"
          >
            {uploading ? '⏳ جاري الرفع...' : '🚀 نشر المحاضرة'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadLecture;
